import type { FeedEvent } from '@/lib/api/apiTypes';
import type { QueryClient } from '@tanstack/react-query';

const CITYWIDE_EVENT_QUERY_KEY = ['citywide-events'] as const;

export function updateCitywideQueries(
  queryClient: QueryClient,
  updateEvent: (event: FeedEvent) => FeedEvent
) {
  queryClient.setQueriesData<FeedEvent[]>(
    { queryKey: CITYWIDE_EVENT_QUERY_KEY },
    (data: FeedEvent[] | undefined) => (data ? data.map(updateEvent) : data)
  );
}
